<template>
  <v-menu
    v-model="menuOpen"
    offset-y
    left
    transition="slide-y-transition"
    min-width="220"
    content-class="ro-profile-menu"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        class="ro-profile-menu__activator"
        size="40"
        v-bind="attrs"
        v-on="on"
      >
        <img :src="avatarSrc" :alt="user_name || 'Profile'">
      </v-avatar>
    </template>

    <v-list dense nav>
      <v-list-item v-if="user_name" class="ro-profile-menu__header">
        <v-list-item-content>
          <v-list-item-title class="font-weight-bold">
            {{ user_name }}
          </v-list-item-title>
          <v-list-item-subtitle v-if="credit !== undefined && credit !== null">
            {{ credit }}
          </v-list-item-subtitle>
          <div v-if="referralCode" class="ro-profile-menu__referral">
            <v-icon
              small
              class="ro-profile-menu__referral-icon"
              :title="$t('header.copy_referral_link')"
              @click.stop="copyReferralLink"
            >
              mdi-content-copy
            </v-icon>
            <span class="ro-profile-menu__referral-code">{{ referralCode }}</span>
          </div>
        </v-list-item-content>
      </v-list-item>

      <v-divider v-if="user_name"></v-divider>

      <v-list-item
        v-for="item in menuItems"
        :key="item.key"
        :to="item.route"
      >
        <v-list-item-icon v-if="item.icon">
          <v-icon>{{ item.icon }}</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ item.label }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider></v-divider>

      <v-list-item @click="onLogout">
        <v-list-item-icon>
          <v-icon>mdi-logout</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{ $t('header.logout') }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
export default {
  name: 'CompNavBarMenuProfile',

  props: [
    'account_id',
    'group_id',
    'currentLocale',
    'reference',
    'user_name',
    'credit',
  ],

  data() {
    return {
      menuOpen: false,
      defaultAvatar: '/img/default-profile.png',
    };
  },

  computed: {
    avatarSrc() {
      return this.defaultAvatar;
    },

    referralCode() {
      return this.reference || 'o6tZw';
    },

    referralLink() {
      return `https://ragnamex.com/r/${this.referralCode}`;
    },

    menuItems() {
      const items = [
        {
          key: 'account_manager',
          label: this.$t('header.account_manager'),
          route: '/account_manager/',
          icon: 'mdi-account-cog',
        },
        {
          key: 'char_manager',
          label: this.$t('header.char_manager'),
          route: '/char_manager/',
          icon: 'mdi-account-group',
        },
        {
          key: 'credit_history',
          label: this.$t('header.credit_history'),
          route: '/credit_history/',
          icon: 'mdi-history',
        },
        {
          key: 'referals',
          label: this.$t('header.referals'),
          route: '/referals/',
          icon: 'mdi-account-multiple-plus',
        },
      ];

      if (Number(this.group_id) === 99) {
        items.push({
          key: 'acm',
          label: this.$t('header.acm'),
          route: '/admin_manager/',
          icon: 'mdi-shield-crown',
        });
      }

      return items;
    },
  },

  methods: {
    onLogout() {
      this.menuOpen = false;
      this.$emit('logout');
    },

    async copyReferralLink() {
      const link = this.referralLink;

      try {
        if (navigator.clipboard && window.isSecureContext) {
          await navigator.clipboard.writeText(link);
        } else {
          const textarea = document.createElement('textarea');
          textarea.value = link;
          textarea.style.position = 'fixed';
          textarea.style.opacity = '0';
          document.body.appendChild(textarea);
          textarea.focus();
          textarea.select();
          document.execCommand('copy');
          document.body.removeChild(textarea);
        }

        this.$emit('referral-link-copied', link);
      } catch (error) {
        this.$emit('referral-link-copy-error', error);
      }
    },
  },
};
</script>

<style scoped>
.ro-profile-menu__activator {
  cursor: pointer;
}

.ro-profile-menu {
  border-radius: 8px;
}

.ro-profile-menu__header {
  pointer-events: none;
}

.ro-profile-menu__referral {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-top: 4px;
  pointer-events: auto;
}

.ro-profile-menu__referral-icon {
  cursor: pointer;
}

.ro-profile-menu__referral-code {
  color: #FFD700;
  font-weight: 600;
  letter-spacing: 0.3px;
}
</style>